var map = {
	"./canto.svg": 1751,
	"./financial_products/dashes.svg": 4490,
	"./financial_products/lineCorner.svg": 875,
	"./linha.svg": 3654,
	"./logo-home.svg": 1176,
	"./opportunities/dashes.svg": 9810,
	"./opportunities/lineCorner.svg": 8014,
	"./parthers/corner.svg": 168,
	"./parthers/industry.svg": 5208,
	"./parthers/know_know.svg": 8244,
	"./parthers/products_services.svg": 5403,
	"./parthers/square.svg": 9175,
	"./products/dashes.svg": 5399,
	"./services/company_certification.svg": 1557,
	"./services/dashes.svg": 8951,
	"./services/gdpr.svg": 5464,
	"./services/it_consultancy.svg": 8034,
	"./services/it_outsourcing.svg": 5286,
	"./services/it_support.svg": 2597,
	"./services/nearshoring.svg": 4753,
	"./team/corner.svg": 3120,
	"./team/dashes.svg": 1607,
	"./team/line.svg": 7786,
	"./team/square.svg": 6857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6351;